const Google = {
  map: null,
  maps: null
}

function isInit() {
  if (Google.map && Google.maps) {
    return true
  }
  // alert('Google Map not initialized!')
  return false
}

export function initial(map, maps) {
  Google.map = map
  Google.maps = maps
}

export function panTo(lat, lng) {
  if (!isInit()) {
    alert('請等到Google Map載入完成再操作')
    return
  }
  Google.map.panTo(new Google.maps.LatLng(lat, lng))
}
